import { fetchJson } from 'kanzler.fetch';

/**
 * @typedef {Object} ProductExtraInfo
 * @property {string} id
 * @property {string} size
 * @property {string} elementXmlId
 * @property {string} elementSectionId
 * @property {string} elementSectionName
 * @property {string} elementSectionPath
 */

/**
 * Fetch catalog data for products
 * @param {string[]|number[]} productIds
 * @returns {Promise<ProductExtraInfo[],Error>}
 */
export function fetchExtraProductOfferInfo(productIds) {
    const queryParams = new URLSearchParams();
    productIds.forEach((offerId) => queryParams.append('offer_ids[]', offerId));

    const offers = [];

    queryParams.forEach((value) => {
        offers.push(value);
    });

    const offersExists = offers.join(':');

    if (!offersExists) {
        location.href = '/personal/cart/';
    }
    else {
        return fetchJson(`/local/ajax/getExtraOfferProductsInfo.php?${queryParams}`)
        .then(response => response.elements);
    }
    
}
